import React from 'react'

import { FiClock, FiMapPin } from 'react-icons/fi'

import { Button, SeverityPill } from '@/components/ui'
import { getSeverityLabel } from '@/insights/components/SeverityDropdown'

import type { AlertSummaryCardProps } from '../types'

const AlertSummaryCard: React.FC<AlertSummaryCardProps> = ({
  name,
  severityCode,
  alertRaisedTime,
  alertClearedTime,
  raisedLocation,
  clearedLocation,
  onRecordActionClick,
  onHideMapClick,
  showMap,
}) => {
  const showTimes = alertRaisedTime !== undefined || alertClearedTime !== undefined

  return (
    <div className="w-full rounded-md bg-white pt-2 pb-2 pl-4 pr-4 shadow-sm flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div className="w-full sm:w-auto">
        <div className="flex flex-row gap-2 items-center">
          <h2 className="text-xl text-primary">{name}</h2>
          {severityCode ? (
            <div className="flex items-center">
              <SeverityPill label={getSeverityLabel(severityCode)} severityCode={Number(severityCode)} />
            </div>
          ) : null}
        </div>
        {showTimes ? (
          <div className="mt-1 flex flex-col sm:flex-row sm:space-x-6 gap-y-1">
            <div>
              <div className="flex flex-row space-x-1 items-center">
                <FiClock className="h-4 w-4" />
                <p className="text-sm text-normal">
                  <span className="text-gray-500">Raised:</span> {alertRaisedTime || '-'}
                </p>
              </div>
              {raisedLocation ? (
                <div className="flex flex-row space-x-1 items-center pl-5">
                  <FiMapPin className="h-3 w-3 text-gray-500" />
                  <p className="text-xs text-gray-500">{raisedLocation}</p>
                </div>
              ) : null}
            </div>
            <div>
              <div className="flex flex-row space-x-1 items-center">
                <FiClock className="h-4 w-4" />
                <p className="text-sm text-normal">
                  <span className="text-gray-500">Cleared:</span> {alertClearedTime || '-'}
                </p>
              </div>
              {clearedLocation ? (
                <div className="flex flex-row space-x-1 items-center pl-5">
                  <FiMapPin className="h-3 w-3 text-gray-500" />
                  <p className="text-xs text-gray-500">{clearedLocation}</p>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
      <div className="flex items-center w-full sm:w-auto gap-4">
        {onHideMapClick && (
          <Button variation="tertiary_outline" size="sm" handleClick={onHideMapClick}>
            {showMap ? 'Hide Map' : 'Show Map'}
          </Button>
        )}
        {onRecordActionClick && (
          <Button variation="primary" size="sm" handleClick={onRecordActionClick}>
            Record Action
          </Button>
        )}
      </div>
    </div>
  )
}

export default AlertSummaryCard
